var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3969fe",
    d: "M717.5,355H645l-18.1-36.3c-12.8-21.1-16.2-36.3-36.3-36.3H409.4c-20,0-23.4,15.2-36.3,36.3L355,355h-72.5c-20,0-36.3,16.2-36.3,36.3v290c0,20,16.2,36.3,36.3,36.3h435c20,0,36.3-16.2,36.3-36.3v-290C753.8,371.2,737.5,355,717.5,355z M500,672.2c-80.1,0-145-64.9-145-145c0-80.1,64.9-145,145-145c80.1,0,145,64.9,145,145C645,607.3,580.1,672.2,500,672.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3969fe",
    d: "M391.2,527.2c0,60.1,48.7,108.8,108.8,108.8s108.8-48.7,108.8-108.8c0-60.1-48.7-108.8-108.8-108.8S391.2,467.1,391.2,527.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.a54862c46b7e0873b741a026dd0e9817.svg";
export { ForwardRef as ReactComponent };